/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './datetime-period.scss';

/* eslint-disable import/no-unresolved, import/default */

import datetimePeriodTemplate from './datetime-period.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.datetimePeriod', [])
    .directive('tkDatetimePeriod', DatetimePeriod)
    .name;

/*@ngInject*/
function DatetimePeriod($compile, $templateCache) {

    var linker = function (scope, element, attrs, ngModelCtrl) {

        var template = $templateCache.get(datetimePeriodTemplate);
        element.html(template);

        ngModelCtrl.$render = function () {
            var date = new Date();
            scope.endDate = date;
            scope.startDate = new Date(date.setDate(date.getDate() - 1));

            if (ngModelCtrl.$viewValue) {
                var value = ngModelCtrl.$viewValue;
                scope.startDate = new Date(value.startTimeMs);
                scope.endDate = new Date(value.endTimeMs);
            }
        };

        scope.updateMinMaxDates = function () {
            scope.maxStartDate = angular.copy(new Date(scope.endDate.getTime() - 1000));
            scope.minEndDate = angular.copy(new Date(scope.startDate.getTime() + 1000));
            scope.maxEndDate = new Date();
        };

        scope.updateView = function () {
            var value = null;
            if (scope.startDate && scope.endDate) {
                value = {
                    startTimeMs: scope.startDate.getTime(),
                    endTimeMs: scope.endDate.getTime()
                };
                ngModelCtrl.$setValidity('datetimePeriod', true);
            } else {
                ngModelCtrl.$setValidity('datetimePeriod', !scope.required);
            }
            ngModelCtrl.$setViewValue(value);
        };

        scope.$watch('required', function () {
            scope.updateView();
        });

        scope.$watch('startDate', function (newDate) {
            if (newDate) {
                if (newDate.getTime() > scope.maxStartDate) {
                    scope.startDate = angular.copy(scope.maxStartDate);
                }
                scope.updateMinMaxDates();
            }
            scope.updateView();
        });

        scope.$watch('endDate', function (newDate) {
            if (newDate) {
                if (newDate.getTime() < scope.minEndDate) {
                    scope.endDate = angular.copy(scope.minEndDate);
                } else if (newDate.getTime() > scope.maxEndDate) {
                    scope.endDate = angular.copy(scope.maxEndDate);
                }
                scope.updateMinMaxDates();
            }
            scope.updateView();
        });

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        require: "^ngModel",
        scope: {
            required: '=ngRequired'
        },
        link: linker
    };
}



// WEBPACK FOOTER //
// ./src/app/components/datetime-period.directive.js